"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _admin = require("../../../../selectors/admin.js");
var _reactRedux = require("react-redux");
var _warning = _interopRequireDefault(require("cccisd-icons/warning"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd.fortress;
var roles = window.cccisd.appDefs.pawn.roles;
var nonManagedRoles = ['metricspawn', 'respondent'];
var RespondentConfig = /*#__PURE__*/function (_React$Component) {
  function RespondentConfig() {
    _classCallCheck(this, RespondentConfig);
    return _callSuper(this, RespondentConfig, arguments);
  }
  _inherits(RespondentConfig, _React$Component);
  return _createClass(RespondentConfig, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        fields = _this$props.fields,
        waves = _this$props.waves,
        restrictionsLevel = _this$props.restrictionsLevel;
      var respondentConfig = fields.respondentConfig,
        respondentSelection = fields.respondentSelection;
      var isSuperUser = Fortress.isSuperUser();
      var isUber = Fortress.user.acting.role.handle === 'uberadmin';
      var respondentConfigOptions = [{
        value: 'anonymous',
        label: 'Anonymous: Respondents are not known until they take the Quest',
        show: true
      }, {
        value: 'manual',
        label: 'Known: I will add the respondents',
        show: true
      }, {
        value: 'previous',
        label: 'Copied: Start with respondents from another Data Collection Wave',
        show: waves.length > 0
      }].concat(_toConsumableArray(isSuperUser || isUber || restrictionsLevel === 'unlimited' ? [{
        value: 'managed',
        label: 'Managed: Allow respondents from my managed participants',
        show: roles && roles.length > 0
      }] : []));
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-info"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-danger"
      }, /*#__PURE__*/_react["default"].createElement(_warning["default"], {
        spaceRight: true
      }), "You will not be able to change this later!"), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        wrapperClassName: "",
        field: respondentConfig,
        label: "How will you pick respondents for this Data Collection Wave?"
      }, respondentConfigOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: option.value,
          className: "form-check"
        }, /*#__PURE__*/_react["default"].createElement("label", {
          className: "form-check-label",
          style: !option.show ? {
            color: '#ccc'
          } : {}
        }, /*#__PURE__*/_react["default"].createElement("input", _extends({
          className: "form-check-input",
          type: "radio"
        }, (0, _cccisdReduxFormHelpers.domOnlyProps)(respondentConfig), {
          value: option.value,
          disabled: !option.show,
          checked: respondentConfig.value === option.value
        })), ' ', option.label));
      })), respondentConfig.value === 'previous' && /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        wrapperClassName: "mt-3",
        field: respondentSelection,
        label: "Select Wave:"
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-select"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(respondentSelection), {
        style: {
          width: 'auto'
        }
      }), /*#__PURE__*/_react["default"].createElement("option", {
        value: ""
      }, "-- Choose a Wave --"), waves.filter(function (w) {
        return !w.parentDeploymentId;
      }).map(function (wave) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: wave.deploymentId,
          value: wave.deploymentId
        }, wave.label, " (", wave.assignment.label, ")");
      }))), respondentConfig.value === 'managed' && /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        wrapperClassName: "mt-3",
        field: respondentSelection,
        label: "Select Role:"
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-select"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(respondentSelection), {
        style: {
          width: 'auto'
        }
      }), /*#__PURE__*/_react["default"].createElement("option", {
        value: ""
      }, "-- Choose a Role --"), roles.filter(function (role) {
        return !nonManagedRoles.includes(role.handle) && role.handle !== 'guest' || isSuperUser && role.handle === 'metricspawn';
      }).map(function (role) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: role.handle,
          value: role.handle
        }, role.label);
      }))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(RespondentConfig, "propTypes", {
  fields: _propTypes["default"].object,
  waves: _propTypes["default"].array,
  restrictionsLevel: _propTypes["default"].string
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    waves: (0, _admin.getCurrentProjectDeployments)(state.assignment.admin),
    restrictionsLevel: (0, _admin.getRestrictionsLevel)(state.assignment.admin)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(RespondentConfig);